module.exports = "<div class=\"mobile_menu_button\" [class.menu_open]=shared.mobile_menu (click)=\"shared.toggleMenu()\">\r\n    <div class=\"mobile_menu_icon\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/mobile-menu-button/mobile-menu-button.component.html
// module id = 742
// module chunks = 0